import { useTranslation } from "react-i18next";
//import syncIcon from "../Assets/gfx/icons/sync-orange.svg";
//import mailIcon from "../Assets/gfx/icons/mail.svg";
import {
  ProfileType,
  RiderModel,
  RiderStatus,
} from "../Api/Models/rider.model";
import { TickFilledIcon } from "./Icons/TickFilledIcon";
import { CarIcon } from "./Icons/CarIcon";
import { BikeIcon } from "./Icons/BikeIcon";
import { CyclistIcon } from "./Icons/CyclistIcon";
import { PoliceIcon } from "./Icons/PoliceIcon";
import { UserLineIcon } from "./Icons/UserLineIcon";
import {ModalSuccessIconProfile} from "./Icons/ModalSuccessIconProfile";

interface ProfileDetailsProps {
  rider: RiderModel;
  gearExchange: boolean;
  hasGear?: boolean;
  gearMissing: number | null;
}

const ProfileDetails: React.FunctionComponent<ProfileDetailsProps> = ({
  rider,
  hasGear,
  gearExchange,
  gearMissing,
}) => {
  const { t } = useTranslation();

  const getVehicleImage = () => {
    if (rider.vehicle === 3) {
      return <CarIcon />;
    }

    if (rider.vehicle === 2) {
      return <BikeIcon />;
    }

    if (rider.vehicle === 4) {
      return <CyclistIcon />;
    }

    /*if (rider.vehicle === 1) {
      return Police;
    }*/
  };

  const getStatusIndicator = () => {


    if (
      rider.status === RiderStatus.INACTIVE ||
      rider.status === RiderStatus.CLEARANCE
    ) {
      return (
        <svg
          fill="none"
          stroke="red"
          strokeWidth={1.5}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          width="24px"
          className="inline"
          style={{ marginLeft: "3px" }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.75 9.75l4.5 4.5m0-4.5l-4.5 4.5M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      );
    }
    console.log(
      rider.profileType === ProfileType.TPATROLLER,
      rider.profileType,
      ProfileType.TPATROLLER
    );

    if (rider.status === RiderStatus.ACITVE) {
      return (
        <div style={{color: '#3F4067'}}>
          <TickFilledIcon />
        </div>
        /*
        <svg
          fill="none"
          stroke="green"
          strokeWidth={1.5}
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          width="24px"
          className="inline"
          style={{ marginLeft: "3px" }}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
        */
      );
    }
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width="20px"
        className="inline"
        style={{ marginLeft: "3px" }}
      >
        <path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z" />
      </svg>
    );
  };

  return (
    <>
    <div className="card border rounded">
      <div className="flex justify-between items-center">
        <div>
          <div className="flex gap-1 items-center">
            {getStatusIndicator()} <span className="text-secondary">{t("Rider ID")}:</span>
          </div>
          <div className="heading">
            {rider.riderId}
          </div>
        </div>
        <div>
          <div className="flex gap-2 items-start">
            {rider.profileType === ProfileType.TPATROLLER && (
              <PoliceIcon />
            )}

            {rider.vehicle && (
              <div className="vehicle-icon">{getVehicleImage()}</div>
            )}

              {rider.profileType === ProfileType.FULL_TIME && (
                  <>
                      {/*<img
                src={FullTime}
                width="25px"
                alt="Police"
                style={{ display: "inline", marginLeft: "5px" }}
              />*/}
                      <div className="vehicle-icon">
                          <UserLineIcon />
                      </div>
                  </>
              )}
          </div>
        </div>
      </div>
      {rider.has_clearance && (
        <>
          <div className="separator-line separator-line--p10"></div>
          <div className="heading-medium mb-0 flex items-center gap-2">
            {t("Clearence")}
            <ModalSuccessIconProfile/>

          </div>

        </>
      )}

        <div className="separator-line separator-line--p10"></div>
        <div className="heading-medium mb-0">{rider.name}</div>

        <div className="text-secondary">{rider.tpl_name}</div>

        <div className="separator-line separator-line--p10"></div>
        <div className="heading-medium mb-0">{t('Contract start date')}</div>
        <div className="text-secondary">{rider.contract_start}</div>
        <div className="separator-line separator-line--p10"></div>
        <div className="heading-medium mb-0">{t('Contract end date')}</div>
        <div className="text-secondary">{rider.contract_end}</div>

    </div>
    </>
  );
};

export default ProfileDetails;
